import React, {useEffect, useState} from 'react';
import {
  Flex,
  FormControl,
  FormHelperText,
  NumberInput,
  NumberInputField,
  Text,
} from '@chakra-ui/react';
import {AiCategoryFieldDefinitionConfig} from '../../../shared/fields/enrichment';
import {ConfigFormLabel} from './ConfigFormLabel';

export const MaxCategoriesEditor = ({
  config,
  isDisabled = false,
  onConfigChange,
}: {
  config: AiCategoryFieldDefinitionConfig;
  isDisabled?: boolean;
  onConfigChange: (config: AiCategoryFieldDefinitionConfig) => void;
}) => {
  const [maxCategories, setMaxCategories] = useState<string>(
    String(config.maxCategories ?? 1)
  );

  useEffect(() => {
    const value = parseInt(maxCategories);
    if (!isNaN(value) && value !== config.maxCategories) {
      onConfigChange({
        ...config,
        maxCategories: value,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maxCategories, onConfigChange]);

  return (
    <FormControl>
      <ConfigFormLabel>Allow Multiple Results? (Optional)</ConfigFormLabel>
      <FormHelperText textColor="kgray.300" mb="3">
        Advanced — Allows your agent to select multiple categories that fit each
        account, if applicable. Keep this set to 1 to only apply the best fit
        category to each account.
      </FormHelperText>
      <Flex fontSize="sm" alignItems="center" gap="1" flexWrap="wrap">
        <Text>Each account may have up to</Text>
        <NumberInput
          mx={1}
          min={1}
          max={99}
          width="40px"
          value={maxCategories}
          clampValueOnBlur={true}
          isDisabled={isDisabled}
          onChange={(valueString) => setMaxCategories(valueString.slice(0, 2))}
        >
          <NumberInputField textAlign="center" px="0" />
        </NumberInput>
        <Text>category/categories applied.</Text>
      </Flex>
    </FormControl>
  );
};
